import { h, defineComponent, ref } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { canSelfServeSubscription, getOrganizationUsersCount, isOnFreePlan } from '@/ui/auth/auth';
import { openNewTab, pushRoute } from '@/ui/helpers';
import { PlanNickName } from '@/entities/plan/constants';
import { SubscriptionSlugNickName } from '@/entities/subscription/constants';
import { ClickProperties } from '@/services/activityTracker/activityTrackerHelper';
import { UpgradeButton } from '@/ui/components/upgrade/UpgradeButton';

interface UpgradeOrSubscribeButtonProps {
  classes?: string;
  propertiesEvent: Partial<ClickProperties>;
}

export const UpgradeOrSubscribeButton = defineComponent<UpgradeOrSubscribeButtonProps>({
  name: 'UpgradeOrSubscribeButton',
  props: ['classes', 'propertiesEvent'],
  setup(props) {
    const isLoading = ref(false);

    const onUpgradeButtonClick = () => {
      if (!canSelfServeSubscription.value) {
        openNewTab(t('links.contact-sales'), false);
        return;
      }

      pushRoute({
        name: 'subscribe',
        query: {
          plan: SubscriptionSlugNickName.ProfessionalNew,
          users: getOrganizationUsersCount().toString(),
          interval: PlanNickName.Yearly,
        },
      });
    };

    const textUpgradeButton = () => {
      if (isOnFreePlan.value) {
        return t('navbar.upgrade');
      }

      if (canSelfServeSubscription.value) {
        return t('navbar.buy-now');
      }

      return t('subscription.contact-sales');
    };

    return function render() {
      return h('div', {
        class: 'button-upgrade-wrapper',
      }, [
        h(UpgradeButton, {
          props: {
            classes: props.classes,
            loading: isLoading.value,
            text: textUpgradeButton(),
          },
          on: {
            click: onUpgradeButtonClick,
          },
        }),
      ]);
    };
  },
});

export const upgradeOrSubscribeButton = (
  { classes = '' }: { classes?: string } = {},
  // if there are two `upgrade` buttons in the same page
  // use the `target` to identify which button is which
  propertiesEvent: Partial<ClickProperties> = { target: '', label: '', page: '' },
) => {
  return h(UpgradeOrSubscribeButton, {
    props: {
      classes,
      propertiesEvent,
    },
  });
};
